/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Note_Code_LabelInputs */

const vi_sinp_note_code_label = /** @type {(inputs: Sinp_Note_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã phiếu`)
};

/**

* @param {Sinp_Note_Code_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_note_code_label = /** @type {((inputs?: Sinp_Note_Code_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Note_Code_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_note_code_label(inputs)
});